import { render, staticRenderFns } from "./UploadCertificates.vue?vue&type=template&id=69ef3d77&scoped=true&"
import script from "./UploadCertificates.vue?vue&type=script&lang=js&"
export * from "./UploadCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef3d77",
  null
  
)

export default component.exports